import script from "./MonitoringSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./MonitoringSidebar.vue?vue&type=script&setup=true&lang=js"

import "./MonitoringSidebar.vue?vue&type=style&index=0&id=349c6c32&lang=scss"

const __exports__ = script;

export default __exports__